import styled from '@emotion/styled';
import { fromThemeColors, ThemeColor } from '@sharefiledev/flow-web';

export const StyledNumberInputWrapper = styled.div`
	padding: 0 8px;
`;

export const StyledPageCounter = styled.div`
	display: flex;
	align-items: baseline;
`;

export const PageSelectorBar = styled.div`
	display: flex;
	align-items: baseline;
	align-self: center;
	justify-content: center;
	flex: 1;
`;

export const PageMoveButtonGroup = styled.div`
	display: flex;
	align-items: baseline;
	justify-content: space-around;
	width: 72px;
	padding-left: 8px;
`;

export const PageMoveButtonWrapper = styled.div`
	background-color: ${fromThemeColors(ThemeColor.secondaryAppBackground)};
	border: 1px solid ${fromThemeColors(ThemeColor.border)};
	height: 24px;
	width: 24px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
`;
